// extracted by mini-css-extract-plugin
export default {"container":"container___CIQly","iconWrapper":"iconWrapper___j9Pd2","icon":"icon___wjuDM","mainText":"mainText___P3449","subText":"subText___Tj_Mn"};